import { render, staticRenderFns } from "./ViewFields.vue?vue&type=template&id=a4cee78c&scoped=true"
import script from "./ViewFields.vue?vue&type=script&lang=js"
export * from "./ViewFields.vue?vue&type=script&lang=js"
import style0 from "./ViewFields.vue?vue&type=style&index=0&id=a4cee78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cee78c",
  null
  
)

export default component.exports